import { render } from "./Product3DViewer.vue?vue&type=template&id=1c7e3742&scoped=true"
import script from "./Product3DViewer.vue?vue&type=script&lang=js"
export * from "./Product3DViewer.vue?vue&type=script&lang=js"

import "./Product3DViewer.vue?vue&type=style&index=0&id=1c7e3742&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7e3742"]])

export default __exports__